
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[org]/reorder-assistant",
      function () {
        return require("private-next-pages/[org]/reorder-assistant.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[org]/reorder-assistant"])
      });
    }
  